const React = require('react');
const PropTypes = require('prop-types');

const GenericModal = require('@cow/core-components/components/GenericModal');

const DiscountTermsModal = ({
  discount,
  deviceType,
  translations,
  showDiscountModal,
  setShowDiscountModal,
  customDiscountLegalTerms,
}) => {
  const getModalContent = () => customDiscountLegalTerms || discount?.detail || null;
  const content = getModalContent();

  if (!content) {
    return null;
  }

  return (
    <GenericModal
      className="discount-modal"
      deviceType={deviceType}
      content={<>{content}</>}
      isOpen={showDiscountModal}
      onClose={() => setShowDiscountModal(false)}
      onOpen={() => setShowDiscountModal(true)}
      title={translations.GENERAL_CONDITIONS}
    />
  );
};

DiscountTermsModal.propTypes = {
  deviceType: PropTypes.string.isRequired,
  translations: PropTypes.shape({}).isRequired,
  setShowDiscountModal: PropTypes.func.isRequired,
  showDiscountModal: PropTypes.bool.isRequired,
  customDiscountLegalTerms: PropTypes.node,
  discount: PropTypes.shape({}),
};

module.exports = DiscountTermsModal;